var sb = require('@sb/util')

function getRateLang (rating) {
	if (!rating) return 'poor'
	if (rating < 2) return 'poor'
	if (rating < 4) return 'average'
	return 'great'
}

export default {
	name: 'InfoMessage',
	props: ['ev'],

	render () {
		// if (this.ev.type === 'conversation_rating_requested') return <div class="info-message"></div>
		if (this.ev.type === 'conversation_rated') {
			var rating = sb.get(this.ev, 'data.conversation.ratings.0', { no_rating: true, rating: 0 })
			if (rating.no_rating) return null
			return (
				<div class="info-message">{this.$t('rated_as') + ' ' + this.$t(getRateLang(rating.rating)).toLowerCase()}</div>
			)
		}
		// if (this.ev.type === 'conversation_state_updated' && sb.get(this.ev, 'data.conversation.state') === 'ended') {
		// 	return <div class="info-message">{this.$t('conversation_ended')}</div>
		// }
		return null
	},
}
